import React, { useEffect, useState } from "react";
import "./SectionTwo.scss";
import {
  Description,
  GreenSubDescription,
  PaymentPendingHeading,
} from "../../../../../Global/GlobalText";
import {
  GreyBorderButton,
  RedBackgroundButton,
} from "../../../../../Global/GlobalButton";
import { IoMdArrowDropleft, IoMdArrowDropright } from "react-icons/io";
import { CheckboxInput } from "../../../../../Global/GlobalFormElement";
import { RxCrossCircled } from "react-icons/rx";
import axios from "axios";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { EXCHNAGE_URL } from "../../../../../../Url/Url";

export const ForJudgeSectionTwo = ({ setSelectedButton, selectedFields, setSelectedFields }) =>{

    const [checkboxes, setCheckboxes] = useState({
        createdOn: false,
        lastUpdate: false,
        endorseStatus: false,
        category: false,
        brandName: false,
        endorsementEmail: false,
        companyGroup: false,
        headOfficeAddress: false,
        contactPersonName: false,
        designation: false,
        mobileNumber: false,
        emailId: false,
      });
    
      const [allSelected, setAllSelected] = useState(false);
      const [showSelected, setShowSelected] = useState(false);
      const [availableFields, setAvailableFields] = useState([]);
      const [selectedCheckboxes, setSelectedCheckboxes] = useState({});
    
      // Define the handleCheckboxChange function
      const handleCheckboxChange = (key) => {
        setSelectedCheckboxes((prev) => ({
          ...prev,
          [key]: !prev[key],
        }));
      };
    
      const handleMoveToSelected = () => {
        const selectedItems = availableFields.filter(
          (field) => selectedCheckboxes[field.field_name]
        );
        setSelectedFields([...selectedFields, ...selectedItems]);
    
        setAvailableFields(
          availableFields.filter((field) => !selectedCheckboxes[field.field_name])
        );
    
        setSelectedCheckboxes({});
      };
    
      const handleMoveToAvailable = () => {
        const deselectedItems = selectedFields.filter(
          (field) => selectedCheckboxes[field.field_name]
        );
        setAvailableFields([...availableFields, ...deselectedItems]);
    
        setSelectedFields(
          selectedFields.filter((field) => !selectedCheckboxes[field.field_name])
        );
    
        setSelectedCheckboxes({});
      };
    
      const token = localStorage.getItem("token");
      const eventIdGet = useSelector((state) => state?.users?.id);
      console.log("evenidget",eventIdGet)
      const eventId = String(eventIdGet);
    
      useEffect(() => {
        const fetchData = async () => {
          try {
            const response = await axios.get(
              `${EXCHNAGE_URL}/fetchFormFields?eventId=${eventIdGet}`,
              {
                headers: { Authorization: `Bearer ${token}` },
              }
            );
            const data = response.data;
            
            if (data.status && data.formSchema?.entryFields) {
              setAvailableFields(data.formSchema.entryFields);
    
              const initialCheckboxes = {};
              data.formSchema.entryFields.forEach((field) => {
                initialCheckboxes[field.field_name] = false;
              });
              setSelectedCheckboxes(initialCheckboxes);
            } else {
              throw new Error("Invalid API response format");
            }
          } catch (error) {
            console.error("Error fetching form fields:", error);
            toast.error("Failed to fetch form fields");
          }
        };
    
        fetchData();
      }, [eventId]);
    
      return (
        <div>
          <div className="financereport_data_div">
            <div className="financereport_white_bg">
              <div className="financereport_main">
                <GreenSubDescription>
                  Select and re-Arrange your columns
                </GreenSubDescription>
    
                <div className="financereport_column_head">
                  <PaymentPendingHeading>Available Columns</PaymentPendingHeading>
                  <div className="financereport_arrow_icon">
                    <IoMdArrowDropleft onClick={handleMoveToAvailable} />
                    <IoMdArrowDropright onClick={handleMoveToSelected} />
                  </div>
                  <PaymentPendingHeading>Selected Columns</PaymentPendingHeading>
                </div>
    
                <div className="financereport_check_section">
                  <div
                    className="financereport_sub_check"
                    style={{ backgroundColor: "#FFE2E54D" }}
                  >
                    <div className="financereport_heading">
                      <h4>Select All</h4>
                    </div>
                    <div className="financereport_checbox_div">
                      <Description>Available Columns</Description>
                      {availableFields.map((field) => (
                        <div
                          key={field.field_name}
                          className="section_four_checkbox"
                        >
                          <CheckboxInput
                            type="checkbox"
                            checked={selectedCheckboxes[field.field_name] || false}
                            onChange={() => handleCheckboxChange(field.field_name)}
                          />
                          <Description>{field.label}</Description>
                        </div>
                      ))}
                    </div>
                  </div>
    
                  <div
                    className="financereport_sub_check"
                    style={{ backgroundColor: "#E2F7E5" }}
                  >
                    <div className="financereport_heading">
                      <h4>Selected Columns</h4>
                    </div>
                    <div className="financereport_checbox_div">
                      <Description>Selected Columns</Description>
                      {selectedFields.map((field) => (
                        <div
                          key={field.field_name}
                          className="section_four_checkbox"
                        >
                          <CheckboxInput
                            type="checkbox"
                            checked={selectedCheckboxes[field.field_name] || false}
                            onChange={() => handleCheckboxChange(field.field_name)}
                          />
                          <Description>{field.label}</Description>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
    
                <div className="section_two_btn">
                  <GreyBorderButton onClick={() => setSelectedButton(1)}>
                    Cancel
                  </GreyBorderButton>
                  <RedBackgroundButton onClick={() => setSelectedButton(3)}>
                    Next
                  </RedBackgroundButton>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    };